// GS-0077 (field audit): nothing in the field waits on signal. boundedCall(promise, ms) settles within ms: it resolves with the promise's value, or rejects with a TimeoutError whose
// message is plain English, so a screen can say "No signal, try again" instead of spinning. The underlying request is not cancelled (supabase-js has no abort here); its late result is ignored.
export class TimeoutError extends Error {
  constructor(message) { super(message || 'This is taking too long. Check your signal and try again.'); this.name = 'TimeoutError'; this.timedOut = true; }
}
export const isTimeout = (e) => !!e && (e.timedOut === true || e.name === 'TimeoutError');

export function boundedCall(promise, ms = 8000, message) {
  let timer;
  const clock = new Promise((_, reject) => { timer = setTimeout(() => reject(new TimeoutError(message)), ms); });
  return Promise.race([Promise.resolve(promise), clock]).finally(() => clearTimeout(timer));
}

/** True for a network-level failure (offline, no signal, DNS) as opposed to a real answer from the server. */
export function isNetworkFailure(e) {
  if (!e) return false;
  if (isTimeout(e)) return true;
  const m = String(e.message || e).toLowerCase();
  return /failed to fetch|networkerror|network request failed|load failed|authretryablefetch|fetch failed|offline/.test(m) || e.name === 'AuthRetryableFetchError' || e.status === 0;
}
